var React = require('react');

function IconplayvideoInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"id":"Ellipse_24","fill":"#A1C842","cx":"20","cy":"20","r":"20","key":0}),React.createElement("path",{"id":"play","fill":"#FFFFFF","stroke":"#FFFFFF","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\tM15.7,11.8l12.8,8.3l-12.8,8.3V11.8z","key":1})]);
}

IconplayvideoInline.defaultProps = {"version":"1.1","id":"Play_Button","x":"0px","y":"0px","viewBox":"0 0 40 40","enableBackground":"new 0 0 40 40","xmlSpace":"preserve"};

module.exports = IconplayvideoInline;

IconplayvideoInline.default = IconplayvideoInline;
